import React from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Box,
} from "@mui/material";

interface CustomDialogProps {
  open: boolean;
  onClose: () => void;
  title?: React.ReactNode;
  children?: React.ReactNode;
  actions?: React.ReactNode;
  // allow overriding Paper sx for larger dialogs
  paperSx?: any;
}

const CustomDialog: React.FC<CustomDialogProps> = ({
  open,
  onClose,
  title,
  children,
  actions,
  paperSx,
}) => {
  return (
    <Dialog
      open={open}
      onClose={onClose}
      PaperProps={{
        sx: {
          borderRadius: 4,
          boxShadow: 8,
          p: 2,
          minWidth: { xs: "90vw", sm: 400 },
          maxWidth: 500,
          bgcolor: "background.paper",
          ...(paperSx || {}),
        },
      }}
    >
      {title && (
        <DialogTitle
          sx={{
            fontWeight: 700,
            fontSize: "1.35rem",
            color: "primary.main",
            pb: 1,
          }}
        >
          {title}
        </DialogTitle>
      )}
      <DialogContent
        sx={{
          px: 3,
          py: 2,
          bgcolor: "background.default",
          borderRadius: 2,
        }}
      >
        <Box sx={{ mt: 1 }}>{children}</Box>
      </DialogContent>
      {actions && (
        <DialogActions
          sx={{
            px: 3,
            pb: 2,
            justifyContent: "flex-end",
            gap: 2,
          }}
        >
          {actions}
        </DialogActions>
      )}
    </Dialog>
  );
};

export default CustomDialog;
